
import { defineComponent, onMounted, ref, computed } from 'vue'

//components
import itemFile from '@/views/tramites/components/itemFile.vue'
import { useI18n } from "vue-i18n/index";
import AuditoryService from "@/core/services/AuditoryService"
import { errManager } from "@/core/config/Tools";
import { useStore } from "vuex";
import moment from 'moment';

export default defineComponent({
    props: {
        id: {
            type: Number,
            required: true,
            default: 0
        },
        target: {
            type: String,
            required: true,
            default: ""
        }
    },
    components: { itemFile },
    setup(props) {
        const { t } = useI18n();
        const loader = ref(false)
        const open_dialog_view_file = ref(false)
        const listItems = ref<any>([])
        const store = useStore();
        //const listHistory = inject<any>('listHistory')

        const username: any = computed < any > (() => {
            return store.getters.currentUser.account;
        });

        const getListItems = async () => {
            loader.value = true
            await AuditoryService.getData({ id: props.id, target: props.target })
                .then((res) => {
                    listItems.value = res.data
                    loader.value = false
                }).catch(({ response }) => {
                    loader.value = false
                    errManager(response)
                })
        }

        onMounted(() => {
            getListItems()
        })

        return {
            t,
            loader,
            moment,
            open_dialog_view_file,
            username,
            listItems,
            getListItems
        }
    }
})
